module.exports = __webpack_public_path__ + "fonts/ArbFONTS-JF-Flat-regular.a742499.ttf";


//////////////////
// WEBPACK FOOTER
// ./assets/ArbFONTS-JF-Flat-regular.ttf
// module id = ./assets/ArbFONTS-JF-Flat-regular.ttf
// module chunks = 54